import { getActiveModifierKeys } from './getActiveModifierKeys.js';

const isEventWithActiveModifierKeys = (event) => {
  const {
    meta,
    shift,
    alt,
    ctrl
  } = getActiveModifierKeys(event);
  return meta || shift || alt || ctrl;
};

export { isEventWithActiveModifierKeys };
//# sourceMappingURL=isEventWithActiveModifierKeys.js.map
